import {
  PerformanceCommentCategoryCreateRequest,
  PerformanceCommentCategoryInputs,
  PerformanceCommentCategoryUpdateRequest,
} from '../../../types/app/peformanceCommentCategory.types';

export const convertDataFromInputToCreateRequest = (
  data: PerformanceCommentCategoryInputs,
): PerformanceCommentCategoryCreateRequest => ({
  id: data.id,
  assetId: data.assetId,
  assetName: data.assetName,
  name: data.name,
  orderingIndex: data.orderingIndex,
});

export const convertDataFromInputToUpdateRequest = (
  data: PerformanceCommentCategoryInputs,
): PerformanceCommentCategoryUpdateRequest => ({
  id: data.id,
  assetId: data.assetId,
  assetName: data.assetName,
  name: data.name,
  orderingIndex: data.orderingIndex,
});
